import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import nl from "./locales/nl.json";
import en from "./locales/en.json";
import es from "./locales/es.json";

const STORAGE_KEY = "em_os_lang";

export const SUPPORTED_LANGS = [
  { code: "nl", label: "Nederlands", flag: "🇳🇱" },
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "es", label: "Español", flag: "🇪🇸" },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      nl: { translation: nl },
      en: { translation: en },
      es: { translation: es },
    },
    fallbackLng: "nl",
    supportedLngs: ["nl", "en", "es"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: STORAGE_KEY,
      caches: ["localStorage"],
    },
  });

export function setLanguage(code) {
  if (!["nl", "en", "es"].includes(code)) return;
  localStorage.setItem(STORAGE_KEY, code);
  i18n.changeLanguage(code);
}

export function getLanguage() {
  return i18n.language?.split("-")[0] || "nl";
}

export default i18n;
